module.exports = __webpack_public_path__ + "static/media/15.8a29415a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/15.png
// module id = 796
// module chunks = 0